export default __webpack_public_path__ + "static/media/MarkPro.4beb1b1e.otf";